import { BgxAbstractParam } from './abstract-param.decorator';

/**
 * Decorator that is used to define which parameter is the http body in a method
 */
export function BgxBody(): (target: object, propertyKey: string | symbol, parameterIndex: number) => void {
  return BgxAbstractParam('body');
}
